module.exports = __webpack_public_path__ + "img/blankscreen_1000.f12d4f41.png";